import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "flex flex-col m-3 lg:m-0 lg:mt-3 lg:-mb-3 lg:ml-3 w-screen font-body bg-dark rounded-md overflow-y-auto",
  id: "timer_wrapper"
}
const _hoisted_2 = { class: "text-center mx-auto" }
const _hoisted_3 = {
  key: 0,
  class: "text-center pt-6 text-md md:text-lg lg:text-xl px-10 md:px-16 text-gray-100"
}
const _hoisted_4 = { class: "text-center pt-6 text-md md:text-lg lg:text-xl px-10 md:px-16 text-gray-100" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "py-7 md:py-5" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  class: "flex",
  id: "scrambleDisplay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.allSessions.length === 0)
        ? (_openBlock(), _createElementBlock("h6", _hoisted_3, " You have no sessions! Create one to Get Started "))
        : _createCommentVNode("", true),
      _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.scramble), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", {
            class: _normalizeClass([{'text-primary': _ctx.timerState == 'ready' }, "font-timer font-light text-7xl lg:text-8xl py-3 lg:py-2 text-gray-50 text-center"])
          }, _toDisplayString(_ctx.formattedTime), 3),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.solveOk())),
              class: "text-gray-50 mx-2 px-3 py-1 font-bold transition duration-150 cursor-pointer rounded hover:bg-gray-50 hover:text-primary bg-primary"
            }, "OK"),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.solvePlusTwo())),
              class: "text-gray-50 mx-2 px-3 py-1 font-bold transition duration-150 cursor-pointer rounded hover:bg-gray-50 hover:text-secondary bg-secondary"
            }, "+2"),
            _createElementVNode("span", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.solveDNF())),
              class: "text-gray-50 mx-2 px-3 py-1 font-bold transition duration-150 cursor-pointer rounded hover:bg-gray-50 hover:text-danger bg-danger"
            }, "DNF")
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_8, null, 512), [
          [_vShow, _ctx.currentSession]
        ])
      ])
    ])
  ]))
}